import { render } from "./ReasonBadge.vue?vue&type=template&id=6787f708"
import script from "./ReasonBadge.vue?vue&type=script&lang=js"
export * from "./ReasonBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__